import { render, staticRenderFns } from "./AttrMedia.vue?vue&type=template&id=10e7b0f6&scoped=true"
import script from "./AttrMedia.vue?vue&type=script&lang=js"
export * from "./AttrMedia.vue?vue&type=script&lang=js"
import style0 from "./AttrMedia.vue?vue&type=style&index=0&id=10e7b0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e7b0f6",
  null
  
)

export default component.exports